import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthService } from '../../service/auth/auth.service';
import { ConfigService } from '../../service/config/config.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {
  
  @Input() modalCtrl: ModalController;
  
  constructor(private config: ConfigService, private http: HttpClient, private alertCtrl: AlertController) { }



  async resetPassword(form:NgForm) {
    let headerOptions = new HttpHeaders({'Content-Type': 'application/json'});

    const options = {
      headers: headerOptions
    };


    if(form.value.cvrnumber) {
      form.value.cvrnumber = form.value.cvrnumber.toLowerCase();
    }
    
    this.http.post<HttpResponse<any>>(this.config.basePath + '/api/farmers/resetPasswordByUsername', form.value, options)
      .subscribe(
        (res) => {
          //console.log('res', Response);
          if (Response) {
            //if (res.status === 200) {
              //console.log(Response);
            //}
          }
        },
        (err: HttpErrorResponse)=>{
          console.log('err', err)
          if (err) {
            if (err.status === 404 || err.status === 500) {
              this.alertMsg("CVR-nummeret kan ikke findes i systemet", "Vi kan desværre ikke finde det indtastede CVR-nummer i systemet. Kontrollér om du har tastet nummeret korrekt og tag ellers fat i avlerinfo.dk");
              console.log("CVR-nummeret findes ikke i systemet");
            }
          }
          },
        ()=>{
          this.closeModal().then(()=>{
            console.log("Done");
            this.alertMsg("Vi har sendt dig et nulstillingslink", "Modtager du ikke linket inden for få minutter, så check venligst om mailen er fanget i dit spamfilter. Kan du stadig ikke findet linket, så kontakt Kristian Dalsgaard på 40293040.");
          
          });
        }
      )
  }

  async alertMsg(header, body){
    let alert = await this.alertCtrl.create({
      header: header,
      subHeader: body,
      buttons: ['OK']
    });
    await alert.present();
  }


  closeModal() {
    return this.modalCtrl.dismiss();
  }

  ngOnInit() {
  }

}
